import Resources from "../resources";
import Dependency from "../../model2/dependency/dependency";
import Task from "../../model2/task/task";
import Project from "../../model2/project/project";
import Event from "../../model2/event/event";


// this method set successors and predecesors fields based on dependencies
// used at least in Gantt

const debug = false
// const debug = "resources_initSuccessorsPredecessors"

export function resources_initSuccessorsPredecessors(resources: Resources) {

    resources.dependencies?.models.map((dependency:Dependency)=>{

        // let source, target

        const source = resources.get(dependency.firstRID) as Task | Event | Project
        const target = resources.get(dependency.secondRID) as Task | Event | Project

        debug && console.log(debug, 'map', source, target)

        if (!source || !target) {
            // console.log("#938476382 - strange case")
            // not && but ||
            // this is used when gantt has dependency to item from outside of this view
            return
        }

        // successors always exist
        // if (source.successors) {
        //     source.successors.add(target)
        // } else {
        //     source.successors = new TasksCollection([target])
        // }
        source.successors.add(target)

        // predecessors always exists
        // if (target.predecessors)    { target.predecessors.add(source) }
        // else                        { target.predecessors = new TasksCollection([source]) }
        target.predecessors.add(source)


    })

}

